import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<a
    [attr.title]="developerName"
    enTooltip
    [routerLink]="discoveryRouterLink"
    [queryParams]="{ developerName: developerName }"
  >
    {{ developerName }}
  </a>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublisherNameComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  developerName;

  ngOnInit(): void {
    super.ngOnInit();
    this.developerName = this.data?.publisherName;
  }
}
